var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1C9.55228 1 10 1.44772 10 2V20C10 20.5523 9.55228 21 9 21C8.44772 21 8 20.5523 8 20V2C8 1.44772 8.44772 1 9 1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3C15.5523 3 16 3.44772 16 4V22C16 22.5523 15.5523 23 15 23C14.4477 23 14 22.5523 14 22V4C14 3.44772 14.4477 3 15 3Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6154 1.2118C23.8581 1.40131 24 1.69207 24 2.00001V20C24 20.4589 23.6877 20.8589 23.2425 20.9702L15.2425 22.9702C15.058 23.0163 14.8642 23.0088 14.6838 22.9487L8.96003 21.0408L1.24254 22.9702C0.943794 23.0448 0.627304 22.9777 0.384588 22.7882C0.141872 22.5987 0 22.3079 0 22V4.00001C0 3.54114 0.312297 3.14116 0.757464 3.02987L8.75746 1.02987C8.94197 0.98374 9.1358 0.991184 9.31623 1.05133L15.04 2.95924L22.7575 1.02987C23.0562 0.955181 23.3727 1.0223 23.6154 1.2118ZM2 4.78079V20.7192L8.75746 19.0299C8.94197 18.9837 9.1358 18.9912 9.31623 19.0513L15.04 20.9592L22 19.2192V3.28079L15.2425 4.97015C15.058 5.01628 14.8642 5.00883 14.6838 4.94869L8.96003 3.04078L2 4.78079Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.3c63b47f94a8b29449979e8935f696f6.svg";
export { ForwardRef as ReactComponent };